module.exports = __webpack_public_path__ + "img/btn_us_flag.1403df56.jpg";